<script setup>
import { ref, onMounted } from 'vue'
import api from '@/services/api'

const loading = ref(true)
const error = ref(null)
const responseData = ref(null)

onMounted(async () => {
  try {
    const payload = {
      identifier: 'afaf300albakri@gmail.com', // أو رقم الجوال
      password: '123Client',
      token_name: 'web',
      type: 'client',
    }

    const { data } = await api.post('/login', payload)

    responseData.value = data   // 👈 هذا هو نفس اللي تشوفه في Postman
  } catch (err) {
    console.error('Login API error:', err)

    error.value = {
      message: err.message,
      url: err.config?.baseURL + err.config?.url,
      status: err.response?.status ?? null,
      response: err.response?.data ?? null,
    }
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div class="p-6">
    <h1 class="mb-4 text-xl font-bold">Login API Test</h1>

    <div v-if="loading">Loading...</div>

    <div v-else-if="error">
      <h2 class="mb-2 font-semibold text-red-600">Error</h2>
      <pre class="p-3 text-sm text-red-700 bg-red-100 rounded">
{{ JSON.stringify(error, null, 2) }}
      </pre>
    </div>

    <div v-else>
      <h2 class="mb-2 font-semibold text-green-600">Response</h2>
      <pre class="p-3 text-sm text-green-400 rounded bg-slate-900">
{{ JSON.stringify(responseData, null, 2) }}
      </pre>
    </div>
  </div>
</template>
